"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_v__baby(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ad7d28e6-5739-4c41-a36b-e91a2a8ea25a",
    "data-name": "ICON",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ac2b6808-bc6d-445c-aef3-2115d33df26f,.b99271ac-a690-4b08-87cf-edda05961f13{fill:none;}.b99271ac-a690-4b08-87cf-edda05961f13{stroke:#333;stroke-linecap:round;stroke-miterlimit:10;stroke-width:8px;}.b4c21d47-5775-4424-b01b-1de554c98ef9{fill:#333;}")), /*#__PURE__*/React.createElement("title", null, "baby"), /*#__PURE__*/React.createElement("ellipse", {
    className: "b99271ac-a690-4b08-87cf-edda05961f13",
    cx: 96,
    cy: 96,
    rx: 54.86,
    ry: 48
  }), /*#__PURE__*/React.createElement("path", {
    className: "b99271ac-a690-4b08-87cf-edda05961f13",
    d: "M150.19,104.14A10,10,0,1,0,156,86a10.2,10.2,0,0,0-5,1.34l-.93.53",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b99271ac-a690-4b08-87cf-edda05961f13",
    d: "M41.81,104.14A10,10,0,1,1,36,86a10.2,10.2,0,0,1,5,1.34l.93.53",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b99271ac-a690-4b08-87cf-edda05961f13",
    d: "M104,64a8,8,0,0,1-16,0c0-5.6,12.18-13.13,11.39-15.91",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b99271ac-a690-4b08-87cf-edda05961f13",
    cx: 116,
    cy: 112,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b99271ac-a690-4b08-87cf-edda05961f13",
    cx: 76,
    cy: 112,
    r: 1.18
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b4c21d47-5775-4424-b01b-1de554c98ef9",
    cx: 76,
    cy: 112,
    r: 5.17
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b4c21d47-5775-4424-b01b-1de554c98ef9",
    cx: 116,
    cy: 112,
    r: 5.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ac2b6808-bc6d-445c-aef3-2115d33df26f",
    width: 192,
    height: 192
  }));
}

var _default = ic_v__baby;
exports.default = _default;